import { useOpenSubscriptionManagement } from 'features/user';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';
import { ID } from 'shared/types/id';

import * as Styled from './subscription-management-links.style';

export type SubscriptionManagementLinksProps = {
  stripeCustomerId?: ID;
  managementUrl?: string;
  isApple?: boolean;
};

export const SubscriptionManagementLinks: React.FC<
  SubscriptionManagementLinksProps
> = ({ stripeCustomerId, managementUrl: initialManagementUrl, isApple }) => {
  const { t } = useTranslation();
  const {
    fetch: fetchStripeManagementUrl,
    url: stripeManagementUrl,
    isLoading,
  } = useOpenSubscriptionManagement(stripeCustomerId);

  const managementUrl = initialManagementUrl ?? stripeManagementUrl;

  const onManageSubscription = () => {
    if (initialManagementUrl) {
      window.open(initialManagementUrl, '_blank');
      return;
    }
    if (!stripeCustomerId) {
      return;
    }
    fetchStripeManagementUrl();
  };

  return managementUrl ? (
    <Styled.Container>
      <Button
        as="a"
        // @ts-ignore
        href={managementUrl}
        target="_blank"
        size={Sizes.Small}
        variant={Variants.Outlined}
        color={Colors.Inherit}
      >
        {t(
          'forms.user-settings.sections.subscriptions.premium.button.update.label',
        )}
      </Button>

      <Button
        as="a"
        // @ts-ignore
        href={managementUrl}
        target="_blank"
        size={Sizes.Small}
        variant={Variants.Outlined}
        color={Colors.Error}
      >
        {t(
          'forms.user-settings.sections.subscriptions.premium.button.cancel.label',
        )}
      </Button>
    </Styled.Container>
  ) : (
    <Button
      onClick={onManageSubscription}
      size={Sizes.Small}
      variant={Variants.Outlined}
      color={Colors.Inherit}
      disabled={isLoading}
    >
      {t(
        isApple
          ? 'forms.user-settings.sections.subscriptions.premium.button.manage-in-ios.label'
          : 'forms.user-settings.sections.subscriptions.premium.button.label',
      )}
      {isLoading && <Styled.ButtonLoader color="primary" size={12} />}
    </Button>
  );
};
